module.exports = __webpack_public_path__ + "static/media/platform-white.de246940.svg";